
import { mapState } from 'vuex'
import LandingMerchantFaq from './LandingMerchantFaq.vue'
import LandingOnboardingIntoPublicAdIntake from './LandingOnboardingIntoPublicAdIntake.vue'
import LandingFeatures from './LandingFeatures.vue'
import LandingHero from './LandingHero.vue'
import LandingKnownFrom from './LandingKnownFrom.vue'
import LandingOnboarding from './LandingOnboarding.vue'
import LandingPageCard from './LandingPageCard.vue'
import LandingReviews from './LandingReviews.vue'
import LandingProducts from './LandingProducts.vue'
import LandingStats from './LandingStats.vue'
import LandingContacts from './LandingContacts.vue'
import LandingFaq from './LandingFaq.vue'
import LandingFaqRef from './LandingFaqRef.vue'
import LandingDivider from './LandingDivider.vue'
import LandingPageCta from './LandingPageCta.vue'
import LandingOnboardingIntoAdIntake from './LandingOnboardingIntoAdIntake.vue'
import LandingLink from './LandingLink.vue'
import LandingMerchantHero from './LandingMerchantHero.vue'
import LandingMerchantFeatures from './LandingMerchantFeatures.vue'
import LandingFullWidthVideoForMobile from '@/components/landing/LandingFullWidthVideoForMobile.vue'
import LandingSimpleListing from '@/components/landing/LandingSimpleListing.vue'
import LandingFullWidthVideo from '@/components/landing/LandingFullWidthVideo.vue'

export default {
  props: {
    withPaddingY: {
      type: Boolean,
      default: true
    },
    attributes: {
      type: Object,
      required: true
    }
  },
  sectionComponents: {
    'landing-page.hero-banner': LandingHero,
    'landing-page.onboarding': LandingOnboarding,
    'landing-page.section-ad-intake-onboarding': LandingOnboardingIntoAdIntake,
    'landing-page.section-onboarding-public-ad-intake': LandingOnboardingIntoPublicAdIntake,
    'landing-page.section-full-width-video-for-mobile': LandingFullWidthVideoForMobile,
    'landing-page.section-full-width-video': LandingFullWidthVideo,
    'landing-page.known-from': LandingKnownFrom,
    'landing-page.landing-page-card': LandingPageCard,
    'landing-page.features': LandingFeatures,
    'landing-page.reviews': LandingReviews,
    'landing-page.products': LandingProducts,
    'landing-page.stats': LandingStats,
    'landing-page.contacts': LandingContacts,
    'landing-page.landing-divider': LandingDivider,
    'faq.faq-question-answer-section': LandingFaq,
    'landing-page.section-cta': LandingPageCta,
    'landing-page.section-ref-faq': LandingFaqRef,
    'landing-page.section-simple-listing': LandingSimpleListing,
    'landing-page.section-link': LandingLink,
    'landing-page.merchant-hero-banner': LandingMerchantHero,
    'landing-page.merchant-features': LandingMerchantFeatures,
    'landing-page.merchant-faq': LandingMerchantFaq
  },
  head () {
    const meta = [
      {
        hid: 'og:title',
        name: 'og:title',
        content: this.title
      },
      {
        hid: 'og:description',
        name: 'og:description',
        content: this.description
      },
      {
        hid: 'description',
        name: 'description',
        content: this.description
      },
      {
        hid: 'og:type',
        name: 'og:type',
        content: 'website'
      }
    ]
    if (this.robots) {
      meta.push({
        name: 'robots',
        content: this.robots
      })
    }
    if (this.fullUrl) {
      meta.push({
        hid: 'og:url',
        name: 'og:url',
        content: this.fullUrl
      })
    }

    return {

      title: this.title,
      meta
    }
  },
  computed: {
    ...mapState('customer', {
      merchant: state => state.merchant
    }),
    isMerchant () {
      return typeof this.merchant?.merchantId === 'number'
    },
    fullUrl () {
      if (process.server && this.$ssrContext) {
        // Server-side: Use $ssrContext to get the req object
        const protocol =
          this.$ssrContext.req.headers['x-forwarded-proto'] || 'http'
        const host = this.$ssrContext.req.headers.host
        const path = this.$ssrContext.req.url
        return `${protocol}://${host}${path}`
      } else if (process.client) {
        // Client-side: Use window.location to get the full URL
        return window.location.href
      } else {
        return undefined
      }
    },
    title () {
      return this.attributes?.title
    },
    description () {
      return this.attributes?.description
    },
    image () {
      return this.attributes.image?.url
    },
    robots () {
      return this.attributes.robots
    },
    paddingY () {
      return this.withPaddingY ? ' sm:py-12 ' : ''
    }
  },
  methods: {
    paddings (section) {
      if (section.paddingBottom) {
        return ` pb-${section?.paddingBottom?.sm} md:pb-${section?.paddingBottom?.md} lg:pb-${section?.paddingBottom?.lg} `
      } else {
        return ' '
      }
    },

    getComponent (section) {
      if (section.__component === 'landing-page.section-onboarding-public-ad-intake' && this.isMerchant) {
        return LandingOnboarding
      }

      return this.$options.sectionComponents[section.__component]
    }
  }
}
